export const NEWSLETTER_POST_TABS = [
  "all",
  "published",
  "scheduled",
  "draft",
] as const;

export const NEWSLETTER_POST_SEARCH_MAX_LENGTH = 255;

export const NEWSLETTER_POST_SEARCH_DEBOUNCE_MS = 500;

export type NewsletterPostTab = (typeof NEWSLETTER_POST_TABS)[number];

export type NewsletterPostTabStatus = Exclude<NewsletterPostTab, "all">;

export const TAB_LABEL_KEYS = {
  all: "common.all",
  scheduled: "common.scheduled",
  draft: "common.drafts",
  published: "common.published",
} as const satisfies Record<NewsletterPostTab, string>;

export const tabStatus = (
  tab: NewsletterPostTab,
): NewsletterPostTabStatus | undefined => (tab === "all" ? undefined : tab);

export const isNewsletterPostTab = (
  value: string,
): value is NewsletterPostTab =>
  NEWSLETTER_POST_TABS.some(tab => tab === value);
